import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    step: {
        docUpload: {
            pleaseOmit: string;
        };
        success: {
            returnToLevis: string;
        };
    };
};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    branchOfServicePlaceholder: 'Branch of Service*',
    firstNamePlaceholder: 'First Name*',
    lastNamePlaceholder: 'Last Name*',
    emailAddressPlaceholder: 'Email Address*',
    dischargeDate: 'Discharge Date',
    birthDate: 'Date of Birth',
    infoShared1: 'Information entered into this web form will be used for verification purposes.',
    infoShared2: ' The information will be shared with LEVI SRAUSS & CO.',
    verifyMyMilitaryStatus: 'Continue',
    tryAgain: 'Try again',
    step: {
        personalInfo: {
            title: 'Verify Your Details',
            subtitle: 'Complete the form below to confirm your eligibility. Fields marked with an asterisk are required.',
        },
        docUpload: {
            title: 'Upload Documentation',
            subtitle: 'To complete verification, please submit any document that clearly shows your name and your specific military affiliation.',
            uploadInstructions: 'Important - Your document must display the following:',
            addFile: 'Add another file...',
            acceptedTypes: 'Accepted formats are: .jpg .jpeg .png .pdf .gif or .bmp',
            pleaseOmit: 'Please omit, cover up, or black out any sensitive information such as Social Security Number, Military ID#, etc. The information we DO need to be visible: first name, last name, valid dates and/or status, for example: "retired" or "active duty".',
        },
        success: {
            title: 'Success',
            subtitle: "You've been verified. Below is your single-use coupon code that is ready for you to use right now. Your single-use coupon code can be used during checkout on Levi's website. The coupon code cannot be combined with any other offer or promotion.",
            returnToLevis: "Please return to <a href='https://www.levi.com/US/en_US/' class='sid-link' target='_blank'>www.levis.com</a> to continue shopping.",
            emailNotification: "To make sure you have every opportunity to use your discount, we're also emailing you a copy of your code and a link to the Levi's website so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all of the details.",
        },
        pending: {
            titleReview: 'Upload Success',
            subtitle: 'Your document has uploaded successfully. The review process has now started. You will be contacted via email in less than 20 minutes with details regarding your verification request.',
            subtitle2: 'NOTE: If you do not recieve an email within the time shown above, you may want to check your spam/junk folder for the message.',
        },
    },
};
